<template>
  <div class="widget-preview-grid">
    <div class="widget-item" v-for="(post, index) of posts" :key="index">
      <widget-preview-item :post="post" :snsType="snsType"></widget-preview-item>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import WidgetPreviewItem from '@/client/components/_atoms/widget_preview_item'

export default defineComponent({
  components: {
    WidgetPreviewItem
  },
  props: {
    posts: Array as PropType<Record<string, any>[]>,
    isViewMessage: Boolean,
    snsType: String
  }
})
</script>

<style lang="scss" scoped>
.widget-preview-grid {
  display: flex;
  flex-wrap: wrap;
}

.widget-item {
  min-width: 25%;
  padding: 4px;
}

@media only screen and (max-device-width: 480px) {
  .item {
    width: 100%;
    break-inside: avoid-column;
  }

  .grid-list {
    column-count: 2;
    column-gap: 0;
  }
}
</style>
